import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import userReducer from './user-reducer';
import gamesMainReducer from '../routes/app/routes/games/routes/main/modules/games-main-reducer';
import gameEditReducer from '../routes/app/routes/games/routes/edit/modules/game-edit-reducer';

export default combineReducers({
    form: formReducer,
    user: userReducer,
    app: combineReducers({
        games: combineReducers({
            main: gamesMainReducer,
            edit: gameEditReducer
        })
    })

});



// WEBPACK FOOTER //
// ./src/js/reducers/index.js